import axios from 'axios'
import authentificationService from '@/services/authentificationService'

class QuotesService {
  getHttpClient () {
    return new Promise((resolve, reject) => {
      if (this.httpClient) {
        resolve(this.httpClient)
      } else {
        authentificationService
          .getConnectedUser()
          .then(connectedUser => {
            this.httpClient = axios.create({
              baseURL: process.env.VUE_APP_API_URL_QUOTES,
              headers: {
                'Authorization': `Basic ${connectedUser.service_token}`
              }
            })
            resolve(this.httpClient)
          })
      }
    })
  }

  findAll (viewParams) {
    const params = {}
    params.equipment = viewParams.equipmentTypes.join(',')
    params.packaging = viewParams.packagingTypes.join(',')
    params.pickupRegion = viewParams.pickupRegions.join(',')
    params.deliveryRegion = viewParams.deliveryRegions.join(',')
    params.size = process.env.VUE_APP_API_SIZE_QUOTES * viewParams.page
    if (viewParams.responded) {
      params.responded = true
    }
    if (viewParams.manageable) {
      params.manageable = true
    }
    params.sort = viewParams.sort
    params['sort.dir'] = 'DESC'

    Object
      .keys(params)
      .filter(key => params[key] === '')
      .forEach(key => delete params[key])

    return this.getHttpClient()
      .then(httpClient =>
        httpClient.get('/', { params })
          .then(response => {
            return {
              pagination: {
                currentPage: Number(response.headers['x-pagination-current-page']),
                entriesPerPage: Number(response.headers['x-pagination-per-page']),
                totalEntries: Number(response.headers['x-pagination-total-entries']),
                totalPages: Number(response.headers['x-pagination-total-pages'])
              },
              quotes: response.data
            }
          })
      )
  }

  findById (id) {
    return this.getHttpClient()
      .then(httpClient =>
        httpClient
          .get(`/${id}`)
          .then(response => response.data)
      )
  }

  findAllResponsesByQuoteId (quoteId) {
    return this.getHttpClient()
      .then(httpClient =>
        httpClient
          .get(`/${quoteId}/responses`)
          .then(response => {
            return {
              pagination: {
                currentPage: Number(response.headers['x-pagination-current-page']),
                entriesPerPage: Number(response.headers['x-pagination-per-page']),
                totalEntries: Number(response.headers['x-pagination-total-entries']),
                totalPages: Number(response.headers['x-pagination-total-pages'])
              },
              responses: response.data
            }
          })
      )
  }

  selectResponse (quoteId, responseId) {
    return this.getHttpClient()
      .then(httpClient =>
        httpClient
          .put(`/${quoteId}/responses/${responseId}/select`, {})
      )
  }
}

export default new QuotesService()
